/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';
import { usePathname } from 'next/navigation';

/* Services */
// import { consoleLog } from '@components/Utility/Shared/SharedService';

/**
 * Renders the Upcoming ProgramCard component
 *
 * @param {object} sectionContent - Content from API.
 * @param {number} number - Big image to show.
 * @param {string} region - Current User country?.
 * @param {string} lang - Current User Language.
 * @param {object} apiType - Api Type of component
 * @returns {ReactElement} Upcoming Program Card component
 */

const UpcomingProgramCard = ({ sectionContent, region, lang }) => {
  const pathname = usePathname();
  let content = sectionContent;
  const isWavesOfBlissUPPage = pathname.includes('wave-of-bliss-uttar-pradesh');

  const formatDateRange = (from, to) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const fromDate = new Date(from);
    const toDate = new Date(to);

    const fromDay = fromDate.getDate();
    const toDay = toDate.getDate();

    const fromMonth = months[fromDate.getMonth()];
    const toMonth = months[toDate.getMonth()];

    const fromYear = fromDate.getFullYear();
    const toYear = toDate.getFullYear();

    if (fromYear === toYear) {
      if (fromMonth === toMonth) {
        return `${fromDay} - ${toDay} ${fromMonth} ${fromYear}`;
      }
      return `${fromDay} ${fromMonth} - ${toDay} ${toMonth} ${fromYear}`;
    }

    return `${fromDay} ${fromMonth} ${fromYear} - ${toDay} ${toMonth} ${toYear}`;
  };

  // Mixpanel
  const mixpanelevent = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track('ie_wave_program_card_click', {
      program_name: content?.title,
      location: content?.locale,
      date_range: formatDateRange(content?.fr, content?.to),
      language: config?.lngList?.[content?.lang],
    });
  };

  const cleanText = text =>
    text
      .replace(/ÃÂ/g, '') // remove mojibake
      .replace(/&nbsp;/g, ' ') // replace HTML non-breaking space
      .replace(/\s+/g, ' ') // collapse multiple spaces
      .trim();

  const getLink = (register_url, region, lang) => {
    if (typeof window === 'undefined') return '';
    const newUrl = refineUrlDomain(register_url, region, lang);
    const url = new URL(newUrl);

    if (!url.searchParams.has('utm_campaign')) {
      url.searchParams.set(
        'utm_campaign',
        isWavesOfBlissUPPage ? 'ie_wave_lucknow' : 'ie_wave_bengaluru'
      );
    }

    const params = new URLSearchParams(window.location.search);
    const voucherCode = params.get('vouchercode');
    if (voucherCode) {
      url.searchParams.set('vouchercode', voucherCode);
    }

    return url.toString();
  };

  return content ? (
    <NextLink
      href={getLink(content?.register_url, region, lang)}
      scroll={false}
      shallow
    >
      <Box
        position="static"
        boxShadow={'0 0 16px 0 rgb(0 0 0 / 15%)'}
        minHeight="261px"
        backgroundColor={'White'}
        textAlign="left"
        color={'black'}
        height={'100%'}
        w={'100%'}
        margin={{ base: '0 auto', md: 'inherit' }}
        onClick={() => mixpanelevent()}
        cursor={'pointer'}
      >
        <Box backgroundColor={'#FCF9F2'} h="202px">
          <Box
            fontFamily="FedraSansStd-A-medium"
            minHeight="125px"
            backgroundColor={'#AE4511'}
            color={'rgb(255 255 255)'}
            fontSize={{ base: '20px' }}
            lineHeight="1.1"
            width={'auto'}
            marginTop={'0'}
            padding="20px 16px 20px 16px"
            clipPath="polygon(0 0, 100% 0, 100% 100%, 0 90%)"
          >
            {cleanText(content?.title || '')}
          </Box>

          <Box fontFamily="FedraSansStd-medium" padding="15px" pt={'0px'}>
            <Text as="span" fontSize="16px" fontFamily="FedraSansStd-medium">
              {formatDateRange(content?.fr, content?.to)}
            </Text>
            <Box fontSize="14px" fontFamily={'FedraSansStd-Book'}>
              {content?.language}
            </Box>
          </Box>
        </Box>
        <Box fontFamily="FedraSansStd-book" fontSize="14px" padding="16px 15px">
          {content?.locale ? `${content?.locale}, ` : ''}
          {content?.city ? `${content?.city} ` : ''}
        </Box>
      </Box>
    </NextLink>
  ) : (
    ''
  );
};

export default UpcomingProgramCard;
